import { z } from 'zod';
import { isoTimestamp, pageQuerySchema } from './common';

export const auditEntryDtoSchema = z.object({
  id: z.uuid(),
  actorUserId: z.uuid().nullable(),
  actorEmail: z.string().nullable(),
  action: z.string(),
  targetType: z.string(),
  targetId: z.string().nullable(),
  diff: z.record(z.string(), z.unknown()).nullable(),
  createdAt: isoTimestamp,
});
export type AuditEntryDto = z.infer<typeof auditEntryDtoSchema>;

export const auditListQuerySchema = pageQuerySchema.extend({
  /** Prefix match on the action, e.g. `agent.` or `agent.publish`. */
  action: z
    .string()
    .trim()
    .regex(/^[a-z0-9_.]{1,100}$/)
    .optional(),
  targetType: z
    .string()
    .trim()
    .regex(/^[a-z0-9_]{1,64}$/)
    .optional(),
  actorId: z.uuid().optional(),
});
export type AuditListQuery = z.infer<typeof auditListQuerySchema>;
